import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { FORM_CONFIGS_TABLE_BORDER } from '@framework/workbench/drawer/ui/table/border/config';
import { Form } from '@tencent/wb-ext-form';
import { config } from '@framework/workbench/ui/border-style/config';
import { ITableBorderFeature } from './table-border-interface';

@Controller({ formItems: FORM_CONFIGS_TABLE_BORDER })
export class TableBorderController {
    constructor(@Loader(ITableBorderFeature) private loader: IDynamicLoader<ITableBorderFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(config.dropdown.data[0].id, 'onClick')
    public handleClick0(): void {
        this.feature.gridMenuInstance.handleMenuClick(0);
    }

    @Form(config.dropdown.data[0].id, 'value')
    public shouldCheck0(): void {
        return this.feature.tableBorderItem[config.dropdown.data[0].id];
    }

    @Form(config.dropdown.data[1].id, 'onClick')
    public handleClick1(): void {
        this.feature.gridMenuInstance.handleMenuClick(1);
    }

    @Form(config.dropdown.data[1].id, 'value')
    public shouldCheck1(): void {
        return this.feature.tableBorderItem[config.dropdown.data[1].id];
    }

    @Form(config.dropdown.data[2].id, 'onClick')
    public handleClick2(): void {
        this.feature.gridMenuInstance.handleMenuClick(2);
    }

    @Form(config.dropdown.data[2].id, 'value')
    public shouldCheck2(): void {
        return this.feature.tableBorderItem[config.dropdown.data[2].id];
    }

    @Form(config.dropdown.data[3].id, 'onClick')
    public handleClick3(): void {
        this.feature.gridMenuInstance.handleMenuClick(3);
    }

    @Form(config.dropdown.data[3].id, 'value')
    public shouldCheck3(): void {
        return this.feature.tableBorderItem[config.dropdown.data[3].id];
    }

    @Form(config.dropdown.data[4].id, 'onClick')
    public handleClick4(): void {
        this.feature.gridMenuInstance.handleMenuClick(4);
    }

    @Form(config.dropdown.data[4].id, 'value')
    public shouldCheck4(): void {
        return this.feature.tableBorderItem[config.dropdown.data[4].id];
    }

    @Form(config.dropdown.data[5].id, 'onClick')
    public handleClick5(): void {
        this.feature.gridMenuInstance.handleMenuClick(5);
    }

    @Form(config.dropdown.data[5].id, 'value')
    public shouldCheck5(): void {
        return this.feature.tableBorderItem[config.dropdown.data[5].id];
    }

    @Form(config.dropdown.data[6].id, 'onClick')
    public handleClick6(): void {
        this.feature.gridMenuInstance.handleMenuClick(6);
    }

    @Form(config.dropdown.data[6].id, 'value')
    public shouldCheck6(): void {
        return this.feature.tableBorderItem[config.dropdown.data[6].id];
    }

    @Form(config.dropdown.data[7].id, 'onClick')
    public handleClick7(): void {
        this.feature.gridMenuInstance.handleMenuClick(7);
    }

    @Form(config.dropdown.data[7].id, 'value')
    public shouldCheck7(): void {
        return this.feature.tableBorderItem[config.dropdown.data[7].id];
    }

    @Form(config.dropdown.data[8].id, 'onClick')
    public handleClick8(): void {
        this.feature.gridMenuInstance.handleMenuClick(8);
    }

    @Form(config.dropdown.data[8].id, 'value')
    public shouldCheck8(): void {
        return this.feature.tableBorderItem[config.dropdown.data[8].id];
    }

    @Form(config.dropdown.data[9].id, 'onClick')
    public handleClick9(): void {
        this.feature.gridMenuInstance.handleMenuClick(9);
    }

    @Form(config.dropdown.data[9].id, 'value')
    public shouldCheck9(): void {
        return this.feature.tableBorderItem[config.dropdown.data[9].id];
    }
}
